document.addEventListener('DOMContentLoaded', function() {
  const faqSection = document.querySelector('.st_faq_and_text_NnEnGw');
  if (!faqSection) return;
  
  const faqItems = faqSection.querySelectorAll('.faq-item, [class*="faq"], [class*="accordion"]');
  
  if (faqItems.length <= 4) return;
  
  faqItems.forEach((item, index) => {
    if (index >= 4) {
      item.style.display = 'none';
      item.classList.add('faq-hidden');
    }
  });
  
  const toggleBtn = document.createElement('button');
  toggleBtn.className = 'faq-toggle-btn';
  toggleBtn.innerHTML = '<span class="toggle-text">Show More</span> <span class="toggle-arrow">▼</span>';
  
  faqItems[3].insertAdjacentElement('afterend', toggleBtn);
  
  toggleBtn.addEventListener('click', function() {
    const hiddenItems = faqSection.querySelectorAll('.faq-hidden');
    const isExpanded = toggleBtn.classList.contains('expanded');
    
    hiddenItems.forEach(item => {
      item.style.display = isExpanded ? 'none' : 'block';
    });
    
    toggleBtn.classList.toggle('expanded');
    toggleBtn.querySelector('.toggle-text').textContent = isExpanded ? 'Show More' : 'Show Less';
    toggleBtn.querySelector('.toggle-arrow').textContent = isExpanded ? '▼' : '▲';
  });
});
